import { render, staticRenderFns } from "./theme-layout.vue?vue&type=template&id=52804032"
import script from "./theme-layout.vue?vue&type=script&lang=js"
export * from "./theme-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports